
export default function Card({ title, children, brand }) {
  return (
    <div className="overflow-visible rounded-2xl border bg-white p-2 sm:p-2 shadow-sm">
      <h3
        className="text-sm font-semibold"
        style={{ color: brand.darkBlue }}
      >
        {title}
      </h3>
      <div className="mt-2 sm:mt-3 space-y-3">{children}</div>
    </div>
  );
}
